
export function generateThicknesses(businessRules) {
  const { thicknesses } = businessRules;
  return thicknesses;
}
